import { cn } from '@lib/ui/cn';
import { ChevronLeft } from 'lucide-react';
import { Link, type To } from 'react-router';

interface IProps {
  className?: string;
  hasBackButton?: boolean;
  path?: string;
  title: string;
}

export function PageTitle({ className, hasBackButton, path, title }: IProps) {
  return (
    <div
      className={cn(
        'text-primary mb-4 flex flex-row items-center justify-start leading-none sm:mb-8',
        className,
      )}>
      <Link
        className={cn(
          !hasBackButton && 'hidden',
          'flex cursor-pointer flex-row items-center gap-2',
        )}
        relative="route"
        title="Voltar"
        to={path ? path : (-1 as To)}
        type="button">
        <ChevronLeft className="size-6 sm:size-8" />
        <h1 className="text-lg font-medium sm:text-2xl">{title}</h1>
      </Link>
    </div>
  );
}
